module.exports = __webpack_public_path__ + "f399ca86187ca9ec940dd4cb2441ecea.pdf";